var map = {
	"./close.png": "04dc",
	"./cup.png": "46f3",
	"./man.png": "6fc6",
	"./medal.png": "1751",
	"./medalUnlock.png": "36f8",
	"./play.png": "f9c9",
	"./slow.png": "907c",
	"./woman.png": "e1c8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2f47";